import React from 'react'
import CloseBtn from './CloseBtn'

interface ModalProps {
  isOpen: boolean
  title?: string
  body: React.ReactNode
  onClose: () => void
  showCloseButton?: boolean
  classStyles?: string
}

const Modal: React.FC<ModalProps> = ({ isOpen, title, body, onClose, showCloseButton = true, classStyles = 'max-w-md' }) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className={`bg-white dark:bg-gray-800 rounded-lg p-6 shadow-xl ${classStyles} w-full overflow-y-auto pt-0`}>
        {title && (
            <>
            <div className="flex justify-between mb-4 sticky top-0 bg-white dark:bg-gray-800 z-10 p-4 rounded-t-lg border-b">
                <h2 className="text-lg font-semibold text-gray-900 dark:text-white text-left text-sm sm:text-lg">{title}</h2>
              <CloseBtn onClick={onClose}></CloseBtn>
            </div>
            
            </>
        )}
        <div className="text-gray-800 dark:text-gray-300 mt-5">{body}</div>
        {showCloseButton && (
          <div className="flex justify-end mt-6">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
            >
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default Modal
